import { useAuth } from './useAuth';

export const useAdmin = () => {
  const { user } = useAuth();
  const isAdmin = user?.email === 'warrick.godfrey@gmail.com';
  
  return {
    isAdmin,
    isLoading: false,
    adminLevel: isAdmin ? 'super_admin' : 'none',
    grantAdminRole: async () => {},
    user
  };
};
